module.exports = __webpack_public_path__ + "static/wimbledon-04-312caf3e81577122c647938388304cc1.jpg";